import React, { useEffect, useState } from "react";
import { Package } from "lucide-react";
import { api } from "../lib/api";

/**
 * Exibe a foto de um produto buscando o binário autenticado do backend
 * (armazenamento de arquivos/mídia). Mostra um ícone de placeholder quando
 * o produto não tem foto cadastrada ou o arquivo falha ao carregar.
 */
export const ProductImage = ({
  fotoPath,
  alt = "",
  className = "",
  iconClassName = "h-6 w-6",
}) => {
  const [src, setSrc] = useState(null);
  const [erro, setErro] = useState(false);

  useEffect(() => {
    setErro(false);
    setSrc(null);
    if (!fotoPath) return;
    let ativo = true;
    let blobUrl = null;
    api
      .get(`/files/${fotoPath}`, { responseType: "blob" })
      .then((r) => {
        if (!ativo) return;
        blobUrl = URL.createObjectURL(r.data);
        setSrc(blobUrl);
      })
      .catch(() => {
        if (ativo) setErro(true);
      });
    return () => {
      ativo = false;
      if (blobUrl) URL.revokeObjectURL(blobUrl);
    };
  }, [fotoPath]);

  if (!fotoPath || erro) {
    return (
      <div
        className={`flex shrink-0 items-center justify-center bg-slate-100 text-slate-300 ${className}`}
        data-testid="product-image-placeholder"
      >
        <Package className={iconClassName} />
      </div>
    );
  }

  if (!src) {
    return (
      <div
        className={`shrink-0 animate-pulse bg-slate-100 ${className}`}
        data-testid="product-image-loading"
      />
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={`shrink-0 object-cover ${className}`}
      data-testid="product-image"
    />
  );
};
